
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from 'src/config/withRouter';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {getSchool,updateStatus,getPermission} from '../store/action';
// firebase
import {db} from '../config/firebase';
import withStyles from '@mui/styles/withStyles';
import { FlagOutlined, ChatBubbleOutlineRounded, OfflineBolt, MoreHorizRounded, EventNote, Widgets } from '@mui/icons-material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Snackbar from '@mui/material/Snackbar';
import Badge from '@mui/material/Badge';

const StyledBadge = withStyles(theme => ({
    badge: {
    backgroundImage: 'linear-gradient(to right, #0AB8E5 , #84E6FF)',
      color:'#fff'
    },
  }))(Badge);

const styles = (props,theme) => ({
    root: {
        bottom: 0,
        width: '100%',
        padding:'0px',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        position: 'fixed',
        fontSize: '8px',
        zIndex: 150,
        height: '3.5rem',
        backgroundColor: '#fff',
        borderTop:'1px solid #EBEBEC',
        fontFamily:'inherit',

        '& .MuiSvgIcon-root': {
            width: '1.4rem',
            height: '1.62rem',
        },
        '& .MuiBottomNavigationAction-root':{
            minWidth: '55px !important',
            padding: '6px 0px 8px',
        },
        '& .MuiBottomNavigationAction-label': {
            color:'#737373',
            fontWeight: '100',
            fontFamily:'inherit'
        },

        '& .Mui-selected': {
            fontWeight: '300',
            color:'#0F467A',
        }

    },

});

class BottomBar extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state={
            newRes:null,
            msj: [],
            message:'',
            open:false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        const { company, update_status, get_school } = this.props;
        const companyId = company && company.id;
        if(companyId && this._isMounted) {
            update_status(companyId)
            get_school(companyId)
            this.newReservation();
            this.getMsj();
        }
        if(this.props.user && this._isMounted) {
            this.props.get_permission(this.props.user.id);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    newReservation = () => {
        this._isMounted = true;
        var compId = this.props.company && this.props.company.companyId;

        var array = [];
        if(compId) {
            db.ref("Reservations/").orderByChild('companyId').equalTo(compId).on('value',(data)=> {
                var allData = data.val()
                if(allData) {
                    for(var i in allData) {
                        if(allData[i].status === 'waiting'){
                            array.push(allData[i])
                        }
                    }
                    if(this._isMounted) {
                        this.setState({newRes:array.length,newresLoading:false})
                    }
                }
            })
        }
    }


    getMsj = () => {
        this._isMounted = true;
        var compId = this.props.company && this.props.company.companyId;
        var array = [];
        if(compId) {
            db.ref('Messages').orderByChild('companyId').equalTo(compId).on('value',(data)=>{
                var msgData = data.val()
                if(!msgData) {
                }
                else{
                for(var i in msgData) {
                    if(!msgData[i].read) {
                        array.push(msgData[i])
                    }
                }
                array.sort( function( a, b){ return a.parentId - b.parentId; } );

                for( var i=0; i<array.length-1; i++ ) {
                    if ( array[i].parentId === array[i+1].parentId && array[i].read) {
                        delete array[i];
                    }
                }
                array = array.filter( function( el ){ return (typeof el !== "undefined"); } );

                for( var i=0; i<array.length; i++ ) {
                    if (array[i].receiverId === array[i].parentId) {
                        delete array[i];
                    }
                }
                array = array.filter( function( el ){ return (typeof el !== "undefined"); } );

                for( var i=0; i<array.length-1; i++ ) {
                    if ( array[i].parentId === array[i+1].parentId) {
                        delete array[i];
                    }
                }

                array = array.filter( function( el ){ return (typeof el !== "undefined"); } );

                if(this._isMounted) {
                    this.setState({msj:array})
                }
            }
            })
        }
    }
    
    msgRedirect = path => {
        let {user,permission,company} = this.props;
        if(company && company.welcomePartner && !company.companyCompleted) {
            this.setState({message:this.props.t('no-access'),open:true})
        }
        else if((user && user.companyId) && !permission.message) {
            this.setState({message:this.props.t('no-access'),open:true})
        }
        else{
            this.props.history.push(path)
        }
    }

    activityRedirect = path => {
        let {user,permission,company} = this.props;
        if(company && company.welcomePartner && !company.companyCompleted) {
            this.setState({message:this.props.t('no-access'),open:true})
        }
        else if((user && user.companyId) && !permission.activity) {
            this.setState({message:this.props.t('no-access'),open:true})
        }
        else{
            this.props.history.push(path)
        }
    }


    resRedirect = (path) => {
        let {user,permission,company} = this.props;
        if(company && company.welcomePartner && !company.companyCompleted) {
            this.setState({message:this.props.t('no-access'),open:true})
        }
        else if((user && user.companyId) && !permission.newRes) {
            this.setState({message:this.props.t('no-access'),open:true})
            // if((user && user.companyId) && !permission.currentRes) {
            // }
            // else {
            //     this.props.history.push(curPath)
            // }
        }
        else{
            this.props.history.push(path)
        }
    }


    render() {
        const{open,message,newRes,msj} =this.state;
        const { classes, t, i18n,status,company } = this.props;
        const _location = window.location.pathname.substring(1);
        const reservationPaths = ['bookings','reservation', 'current-reservation', 'group-reservation', 'appointments', 'today-report', 'week-report', 'month-report', 'select-report'];
        const resPath = reservationPaths.filter(v => v === _location)[0];
        const isRTL = i18n.translator.language;
        let dom;
        const pathname = this.props.location.pathname;
        const iswelcomePartner = company && company.welcomePartner && !company.companyCompleted || pathname === '/welcome-partner'; 
        let navValue = pathname === '/' ? 'dashboard' : pathname.slice(1);
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? {fontFamily: ar} : {fontFamily: en}; 
            dom = (
                <div dir={isRTL === 'ar' ? 'rtl' :'ltr'} style={fontFamily} pb={this.props.padding}>
                    <BottomNavigation
                        value={navValue}
                        showLabels
                        className={classes.root}
                    >
                        <BottomNavigationAction
                            label={iswelcomePartner ? t('partner.dashboard.welcome') : t('component.bottombar.dashboard')}
                            value={iswelcomePartner ? 'welcome-partner' : 'dashboard'}
                            icon={iswelcomePartner ? <FlagOutlined /> : <Widgets />}
                            component={Link}
                            to={iswelcomePartner ? "/welcome-partner" : "/dashboard"} />

                        <BottomNavigationAction
                        jaj={isRTL === "ar" ? '3px' : '10px'}
                            label={t('component.bottombar.service')}
                            value='services'
                            icon={<OfflineBolt />}
                            onClick={()=>this.activityRedirect('/services')}
                            />

                        <BottomNavigationAction
                            label={t('partner.dashboard.bookings')}
                            value={resPath}
                            icon={
                                newRes ?
                                <StyledBadge badgeContent=" " variant='dot' overlap="circular">
                                    <EventNote />
                                </StyledBadge>
                                :
                                <EventNote />
                                }
                            onClick={()=> status.status && status.resolve ? this.resRedirect('/bookings') : undefined}
                            />
                        <BottomNavigationAction
                            label={t('parentDashboard.support')}
                            value='message'
                            icon={<ChatBubbleOutlineRounded />}
                            onClick={()=> window.open('https://wa.me/+966540791835','_blank')}
                        />
                        <BottomNavigationAction
                            label={t('component.bottombar.more')}
                            value='more'
                            icon={<MoreHorizRounded />}
                            component={Link}
                            to="/more" />
                    </BottomNavigation>
                    <Snackbar
                        anchorOrigin={{ vertical:'top', horizontal:'center' }}
                        key='top center'
                        open={open}
                        autoHideDuration={500}
                        onClose={()=>this.setState({open:false})}
                        ContentProps={{
                        'aria-describedby': 'message-id',
                        }}
                        message={<span id="message-id" style={fontFamily}>{message}</span>}
                    />
                </div>
            )
        return dom;
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.mainMenu,
        user: state.user,
        company:state.company,
        lang: state.lang,
        status: state.status,
        permission: state.permission
    };
};

const mapDispatchToProps = dispatch => {
    return {
        get_school : (id) => dispatch(getSchool(id)),
        update_status : id => dispatch(updateStatus(id)),
        get_permission : id => dispatch(getPermission(id))
    }
}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(withTranslation('common')(BottomBar)))
);
